import request from '@/utils/request'

export function userinfo (data) {
  return request({
    url: 'user/userinfo',
    method: 'POST',
    params: data
  })
}

export function getUser (data) {
    return request({
      url: 'user/user',
      method: 'get',
      params: data
    })
  }
  